import { useTranslation } from '@/i18n';
import { Layout } from '@/Layout';
import {
  ButtonV2,
  ListView,
  ListViewBody,
  ListViewLabel,
  Single,
  TextLink,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { useState } from 'react';
import styles from './BusinessDocumentSetting.module.scss';

const cx = classnames.bind(styles);

export const BusinessDocumentSetting = () => {
  const flagshipUrl = '/billing_history';
  const [isActive, setIsActive] = useState(false);
  const { t } = useTranslation();

  const toggleActive = () => {
    setIsActive((prevState) => !prevState);
  };

  return (
    <Layout>
      <div className={cx(styles['container'])}>
        <div className={cx(styles['list-header-container'])}>
          <div className={cx(styles['section-heading'])}>
            {t('business_document_setting_title')}
          </div>
          <div className={cx(styles['description-container'])}>
            <div className={cx(styles['description-inner'])}>
              <div className={cx(styles['description'])}>
                {t('business_document_setting_description')}
              </div>
              <TextLink href={flagshipUrl}>
                {t('business_document_setting_history')}
              </TextLink>
            </div>
            <ButtonV2
              color='primary'
              isSecondary
              type='button'
              isLoading={isActive}
              onClick={() => toggleActive()}
            >
              {t(isActive ? 'use_start' : 'use_end')}
            </ButtonV2>
          </div>
        </div>
        <ListView>
          <Single>
            <ListViewLabel>
              <div className={cx(styles['label'])}>
                {t('business_document_setting_use_function')}
              </div>
            </ListViewLabel>
            <ListViewBody>{t(isActive ? 'not_use' : 'use')}</ListViewBody>
          </Single>
        </ListView>
      </div>
    </Layout>
  );
};
